import './Service.css'
import React, { FC, useState } from 'react'
import { Card, Avatar, Space, Flex, Anchor } from 'antd'
import { Service } from '../../types/index'
import { insertThousandSeparator, useCommaAsDecimalPoint } from '../../utils/converters'
import { useResponxiveContext } from '../../context/responsive-context'
const { Meta } = Card

export const ServiceCard: FC<Service> = (service) => {
  const { useVertical } = useResponxiveContext()
  return (
    <a href="#book" >
    <div style={{alignItems: 'center'}}>
          <Card
        className={useVertical ? "Service-card-vertical" : "Service-card"}
        hoverable
        cover={
          <div
          style={useVertical ? {
            overflow: "hidden",
            width: "96%",
            height: "55vh",
            borderRadius: "30px",
            margin: "auto",
            marginTop: "2%"
          } : {
            overflow: "hidden",
            width: "96%",
            height: "400px",
            borderRadius: "30px",
            margin: "auto",
            marginTop: "2%"
          }}
            >
            <img className={useVertical ? "Service-card-image-vertical" : "Service-card-image"}
            src={service.metadata.pictureUrl} />
    </div>
        }
      >
        <Meta
          title={<div className="Service-card-title">{service.name}</div>}
          description={
            <div className="Service-card-body" style={{ height: '100%'}}>
            <div style={{height: 75}}>
              { service.metadata.description }
            </div>
            <Flex vertical justify={'space-around'}>
            <div>
              Időtartam: { useCommaAsDecimalPoint(service.metadata.durationMinHours) } - { useCommaAsDecimalPoint(service.metadata.durationMaxHours) } óra
            </div>
            <div style={{ fontWeight: 'bold', color: 'black' }}>
              Ár: { insertThousandSeparator(service.metadata.price) } Ft{ service.metadata.priceUnit && `/${service.metadata.priceUnit}` }
            </div>
            </Flex>
            </div>
          }
        />
      </Card>
      </div>
      </a>
  )
}

